import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import {
  useAddFormValidation
} from "../../core/hooks/useAddFormValidation/useAddFormValidation.js";
import {
  useValidateYupSchema
} from "../../validators/useValidateYupSchema.js";
import { FormProvider } from "../FormProvider/FormProvider.js";
import { FormLayout } from "./components/FormLayout.js";
const noopOnValidate = () => {
};
const schemaPlaceholder = {};
function FormBody(props) {
  const {
    onValidate = noopOnValidate,
    onValidateOptions,
    onValidateYupSchema = schemaPlaceholder,
    onValidateYupSchemaOptions,
    ...formProps
  } = props;
  const options = useMemo(
    () => Object.assign({}, onValidateOptions, { disabled: onValidate === noopOnValidate }),
    [onValidate, onValidateOptions]
  );
  useAddFormValidation(onValidate, options);
  const yupSchemaOptions = useMemo(
    () => Object.assign({}, onValidateYupSchemaOptions, { disabled: onValidateYupSchema === schemaPlaceholder }),
    [onValidateYupSchema, onValidateYupSchemaOptions]
  );
  useValidateYupSchema(onValidateYupSchema, yupSchemaOptions);
  return /* @__PURE__ */ jsx(FormLayout, { ...formProps });
}
function Form(props) {
  const { config, verbose, children, onInitialize, onFormApi, ...formProps } = props;
  return /* @__PURE__ */ jsx(FormProvider, { config, verbose, onInitialize, onFormApi, children: /* @__PURE__ */ jsx(FormBody, { ...formProps, children }) });
}
export {
  Form
};
//# sourceMappingURL=Form.js.map
